import styled from "styled-components";

export const Main = styled.main`
  margin-top: ${({ theme }) => theme.heightSize.HEADER_HEIGHT_COVERAGE + 20}px;
  min-width: ${({ theme }) => theme.widthSize.minimum};
`;
